"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const OrganicIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.766 3.27c-3.05 1.873-2.874 4.924-2.77 6.053 3.94-4.939 9.832-4.7 9.832-4.7S3.476 7.657 1.023 13.738c-.194.48.909 1.105 1.16.537a14.324 14.324 0 011.798-2.96c1.544.609 4.216 1.322 6.109-.089 2.515-1.873 2.258-6.026 5.848-8.048.839-.472-7.037-2.447-11.172.093z"
  })))
});
OrganicIcon.displayName = 'OrganicIcon';
var _default = exports.default = OrganicIcon;